import { styled } from '../jss-style';
import treeStyle from './tree';

const useTreeStyle = styled(treeStyle, 'tree');
export { treeStyle, useTreeStyle };
export default useTreeStyle;
